import { module } from 'angular';
import { ngModule as foundationDictionaryModule } from 'cg-foundation-dictionary';
import { ngModule as foundationPricingModule } from 'cg-foundation-pricing';
import { ngModule as foundationThemingModule } from 'cg-foundation-theming';
import { AddToCompareButtonComponent } from './components/add-to-compare-button';
import { CompareListComponent } from './components/compare-list';
import { CompareTableComponent } from './components/compare-table';
import { CompareTableCellComponent } from './components/compare-table-cell';
import { CompareTableSectionComponent } from './components/compare-table-section';
import { CompareListEventsDirective } from './directives/compare-list-events';
import { CompareListOnHoverDirective } from './directives/compare-list-on-hover';
import { CompareChannelService } from './services/compare-channel';
import { CompareListEventsService } from './services/compare-list-events-service';
import { CompareTableConfigurationService } from './services/compare-table-configuration-service';
import '../scss/_master.scss';
export var ngModule = module('gn.audio.cg.compare', [
    foundationDictionaryModule.name,
    foundationThemingModule.name,
    foundationPricingModule.name,
])
    .service('compareChannel', CompareChannelService)
    .service('compareListEvents', CompareListEventsService)
    .service('compareTableConfiguration', CompareTableConfigurationService)
    .directive('compareListEvents', CompareListEventsDirective)
    .directive('compareListOnHover', CompareListOnHoverDirective)
    .component('addToCompareButton', AddToCompareButtonComponent)
    .component('compareList', CompareListComponent)
    .component('compareTable', CompareTableComponent)
    .component('compareTableCell', CompareTableCellComponent)
    .component('compareTableSection', CompareTableSectionComponent);
